import { Link, useNavigate } from "react-router-dom";
import { Formik } from "formik";
import * as Yup from "yup";
import { useMutation } from "@tanstack/react-query";
import { ArrowLeft } from "lucide-react";

import { forgotPassword } from "src/api/auth";
import AuthField from "src/components/auth/AuthField";
import AuthHeading from "src/components/auth/AuthHeading";
import { Button } from "src/components/ui/button";
import { showSuccessToast } from "src/lib/utils";

const validationSchema = Yup.object().shape({
	email: Yup.string().email("Invalid email address").required("Email is required"),
});

const ForgotPassword = () => {
	const navigate = useNavigate();

	const { mutate, isLoading } = useMutation(forgotPassword, {
		onSuccess: ({ message }) => {
			showSuccessToast(message || "Check your email for a reset code");
			navigate("/reset-password");
		},
	});

	return (
		<>
			<AuthHeading title="Forgot password" subtitle="We'll email you a code to set a new password." />

			<Formik initialValues={{ email: "" }} validationSchema={validationSchema} onSubmit={(values) => mutate(values)}>
				{({ values, handleChange, handleBlur, handleSubmit, errors, touched }) => (
					<form onSubmit={handleSubmit} className="tw-space-y-4">
						<AuthField
							label="Email"
							name="email"
							type="email"
							placeholder="you@business.com"
							value={values.email}
							onChange={handleChange}
							onBlur={handleBlur}
							error={touched.email && errors.email}
							autoComplete="email"
						/>

						<Button type="submit" disabled={isLoading} className="tw-w-full tw-bg-teal tw-text-white hover:tw-bg-teal-dark">
							{isLoading ? "Sending..." : "Continue"}
						</Button>

						<p className="tw-text-center">
							<Link
								to="/login"
								className="tw-inline-flex tw-items-center tw-gap-1.5 tw-text-[13px] tw-font-semibold tw-text-teal hover:tw-underline"
							>
								<ArrowLeft className="tw-h-3.5 tw-w-3.5" />
								Back to login
							</Link>
						</p>
					</form>
				)}
			</Formik>
		</>
	);
};

export default ForgotPassword;
